export const limboGameReturnToPlayer = 99

export const targetMultiplierMax = 1000000
export const targetMultiplierMin = 1.01
